import { format, isValid, parseISO } from 'date-fns';

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (!isValid(date)) return '';
  return format(date, 'yyyy-MM-dd HH:mm');
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (!isValid(date)) return '';
  return format(date, 'yyyy-MM-dd');
};

const formatCurrency = (
  value,
  currency = "JPY",
  locale = "ja-JP"
) => {
  if (value == null) return "";

  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);

  // 日本円だけは「￥」を除いて「 円」に
  if (currency === "JPY") {
    return formatted.replace("￥", "") + " 円";
  }

  return formatted;
};

export { formatDate, formatDateTime, formatCurrency };
